<template>
  <div id="top-section" class="top-section" :style="{ height: computedHeight }">
    <h3>{{ $t('welcom_to_comic_series') }}</h3>
    <div class="store-btn_view">
      <div class="btn_view">
        <a
          href="https://apps.apple.com/us/app/id6748986455"
          target="_blank"
        >
          <img src="@/assets/image/app-store.png">
        </a>
      </div>
      <div class="btn_view">
        <a
          href="https://play.google.com/store/apps/details?id=com.cubeani.magicube"
          target="_blank"
        >
          <img src="@/assets/image/app-google.png">
        </a>
      </div>
    </div>
    <div style="margin-top: 30px" />
  </div>
</template>

<script>
export default {
  name: 'TopSection',
  data() {
    return {
      baseHeight: 980,
      aspectRatio: 4.0 / 2.0,
      containerWidth: window.innerWidth,
    }
  },
  computed: {
    computedHeight() {
      if (this.$route.path === '/download') {
        return '100vh'
      } else {
        return `${this.containerWidth / this.aspectRatio}px`
      }
    },
    computedFontImg() {
      return `${this.containerWidth / this.aspectRatio / 4.5}px`
    },
    isDownloadPage() {
      return this.$route.path === '/download'
    },
  },
  mounted() {
    this.updateHeight()
    window.addEventListener('resize', this.updateHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateHeight)
  },
  methods: {
    updateHeight() {
      this.containerWidth = this.$el ? this.$el.clientWidth : window.innerWidth
    },
  },
}
</script>

<style lang="scss" scoped>
@keyframes side-top-bottom {
  0% {
    transform: translateY(-1000px) scale(0.8);
  }
  50% {
    transform: translateY(0) scale(0.8);
  }
  100% {
    transform: translateY(0) scale(1);
  }
}
.top-section {
  background: url('@/assets/image/img_banner.png') no-repeat center center;
  backdrop-filter: blur(0.106667rem);
  object-fit: cover;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  user-select: none;
  position: relative;
  h3 {
    font-weight: bold;
    font-size: 58px;
    color: #fff;
    letter-spacing: 2px;
    width: 60%;
    text-align: center;
    animation: side-top-bottom 1.5s ease-in-out forwards;
    @media screen and (max-width: 768px) {
      font-size: 29px;
    }
  }
  img {
    width: 250px;
    height: 80px;
    margin-top: 30px;
  }
  .store-btn_view {
    display: flex;
    gap: 20px;
    height: 90px;
    align-items: flex-end;
    .btn_view {
      position: relative;
      display: flex;
      flex-direction: column;
      img {
        width: 180px;
        height: 60px;
        margin: 0;
      }
      span {
        color: #fff;
        text-align: center;
        font-size: 16px;
      }
    }
  }
  .local-api_btn {
    width: 100px;
    cursor: pointer;
  }
}

.apple-store_view {
  width: 100%;
  position: absolute;
  top: 65px;
  text-align: center;
}

.apple-store_text {
  font-size: 16px;
}
</style>
